exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.white-button[data-v-aee0d02c] {\n  color: #000;\n}", "", {"version":3,"sources":["C:/Users/Nokia/Documents/code/MC/mcFrontend/src/components/common/tabs/tabs_task_list/tab_task_option.vue"],"names":[],"mappings":";AAAA;EACE,YAAY;CACb","file":"tab_task_option.vue","sourcesContent":[".white-button {\n  color: #000;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":true,"importLoaders":2}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aee0d02c","scoped":true,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":54}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/tabs/tabs_task_list/tab_task_option.vue
// module id = 5zih
// module chunks = 1